export default {
    getMenuPath(state:any, status:any) {
        for(let i=0;i<state.activeMenu.length;i++){ 
          if(state.activeMenu[i].status){
            return {path:state.activeMenu[i].path}
          }         
        }
        return {path:''}
    }
}